export default "__VITE_ASSET__Dt78QF2o__"